<template>
  <div class="period">
    <DatePicker
      :value="startDate"
      :minDate="minDate"
      :maxDate="maxDate"
      :inputWidth="inputWidth"
      @change="onChangeStartDate"
      @setDateError="onSetDateError"
      ref="startComp"
      keyName="start"
    />
    <span class="dash">~</span>
    <DatePicker
      :value="endDate"
      :minDate="minDate"
      :maxDate="maxDate"
      :inputWidth="inputWidth"
      @change="onChangeEndDate"
      @setDateError="onSetDateError"
      ref="endComp"
      keyName="end"
    />
  </div>
</template>

<script>
export default {
  props: {
    startDate: {
      type: [ Date, Number, String ],
      default() { return new Date() }
    },
    endDate: {
      type: [ Date, Number, String ],
      default() { return new Date() }
    },
    minDate: {
      type: [ Date, Number, String ],
    },
    maxDate: {
      type: [ Date, Number, String ],
    },
    inputWidth: null,
    maxPeriod: String, // 7d 1m 1y
  },
  data() {
    const selectedStartDate = this.startDate
    const selectedEndDate = this.endDate
    selectedStartDate.setHours(0, 0, 0, 0)
    selectedEndDate.setHours(23, 59, 59, 999)
    return {
      minDateForEndDate: null,
      maxDateForStartDate: null,
      selectedStartDate,
      selectedEndDate
    }
  },
  watch: {
    selectedStartDate() {
      this.$emit('change')
    },
    selectedEndDate() {
      this.$emit('change')
    }
  },
  methods: {
    // dat"e" 는 시작일 리턴
    getDate() {
      return new Date(this.selectedStartDate)
    },
    getData() {
      const startDate = new Date(this.selectedStartDate)
      const endDate = new Date(this.selectedEndDate)
      startDate.setHours(0,0,0,0)
      endDate.setHours(23,59,59,999)
      return { startDate, endDate }
    },
    onChangeStartDate(date) {
      this.selectedStartDate = date
      if (this.selectedEndDate < this.selectedStartDate) this.$refs.endComp.setDate(this.selectedStartDate)
      else if (this.maxPeriod) {
        const maxDate = this.$utils.calcDate(this.selectedStartDate, this.maxPeriod);
        if (this.selectedEndDate > maxDate) {
          this.$refs.endComp.setDate(maxDate);
          this.$emit('maxPeriodError');
        }
      }
    },
    onChangeEndDate(date) {
      this.selectedEndDate = date
      if (this.selectedEndDate < this.selectedStartDate) this.$refs.startComp.setDate(this.selectedEndDate)
      else if (this.maxPeriod) {
        const minDate = this.$utils.calcDate(this.selectedEndDate, `-${this.maxPeriod}`);
        if (this.selectedStartDate < minDate) {
          this.$refs.startComp.setDate(minDate);
          this.$emit('maxPeriodError');
        }
      }
    },
    onSetDateError(type) {
      this.$emit('setDateError', type)
    },

    onSetDate(startDate, endDate) {
      this.selectedStartDate = startDate;
      this.selectedEndDate = endDate;
      this.selectedStartDate.setHours(0,0,0,0);
      this.selectedEndDate.setHours(0,0,0,0);
      this.$refs.startComp.setDate(this.selectedStartDate);
      this.$refs.endComp.setDate(this.selectedEndDate);
    },

  },
  mounted() {
    this.$emit('change')
  }

}
</script>
